var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ib-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "400px",
        "show-close": false,
        "empty-header": "",
      },
      on: { close: _vm.closeDialog },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("ib-divider", { staticClass: "mb-4", attrs: { block: "" } }),
              _c("ib-dialog-footer", {
                attrs: {
                  "button-size": "md",
                  "cancel-btn-text": _vm.$t("cancel"),
                  "submit-btn-text": _vm.$t("confirm"),
                  loading: _vm.loading,
                },
                on: { cancel: _vm.closeDialog, submit: _vm.confirmDialog },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("ib-dialog-confirmation-content", {
        attrs: {
          image: require("@/assets/img/illustrations/dialogs/upgrade-rocket.svg"),
          title: _vm.$t("dialogs.upgradePricePlan.pricePlanChange"),
        },
      }),
      _c("div", { staticClass: "o-50 mx-4 mt-3" }, [
        _c("p", { staticClass: "text-lead m-0" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("dialogs.upgradePricePlan.newPlan")) + ": "),
          ]),
          _c("span", [
            _vm._v(_vm._s(_vm.isLifetime ? "Lifetime Offer" : _vm.record.slug)),
          ]),
          _vm._v(" / "),
          _c(
            "span",
            [
              _vm._v(" " + _vm._s(_vm.record.ideas) + " "),
              _vm.record.ideas > 1
                ? [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("dialogs.upgradePricePlan.ideas")) +
                        " "
                    ),
                  ]
                : [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("dialogs.upgradePricePlan.idea")) +
                        " "
                    ),
                  ],
            ],
            2
          ),
          _vm._v(" / "),
          !_vm.isLifetime
            ? _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.record.type === "month"
                        ? _vm.$t("monthly")
                        : _vm.$t("annually")
                    ) +
                    " "
                ),
              ])
            : _c("span", { staticClass: "text-capitalize" }, [
                _vm._v(" " + _vm._s(_vm.$t("pages.pricing.lifetime")) + " "),
              ]),
        ]),
        _vm.previewData &&
        _vm.previewData.response &&
        _vm.previewData.response.immediate_payment
          ? _c("p", { staticClass: "text-lead m-0" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("dialogs.upgradePricePlan.billedImmediately")) +
                    ": "
                ),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.previewData.response.immediate_payment.currency) +
                    " " +
                    _vm._s(
                      _vm.previewData.response.immediate_payment.amount.toFixed(
                        2
                      )
                    )
                ),
              ]),
            ])
          : _vm._e(),
        _c("p", { staticClass: "text-lead m-0" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("dialogs.upgradePricePlan.newRate")) + ": "),
          ]),
          _c("span", { staticClass: "price" }, [
            _vm.previewData.success
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.previewData.response.next_payment.currency) +
                      " " +
                      _vm._s(
                        _vm.previewData.response.next_payment.amount.toFixed(2)
                      ) +
                      " "
                  ),
                ])
              : _vm._e(),
            _c(
              "span",
              { staticClass: "price-text" },
              [
                _vm.record.type === "month"
                  ? [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("dialogs.upgradePricePlan.perMonth")) +
                          " "
                      ),
                    ]
                  : _vm._e(),
                _vm.record.type === "year"
                  ? [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("dialogs.upgradePricePlan.perYear")) +
                          " "
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
        _vm.previewData &&
        _vm.previewData.response &&
        _vm.previewData.response.next_payment
          ? _c("p", { staticClass: "text-lead m-0" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("dialogs.upgradePricePlan.nextBillingDate")) +
                    ": "
                ),
              ]),
              _vm.isLifetime
                ? _c("span", [_vm._v("N/A")])
                : _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm
                          .$moment(_vm.previewData.response.next_payment.date)
                          .format("MMM Do, Y")
                      )
                    ),
                  ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }